import { render, staticRenderFns } from "./DependencyAdder.vue?vue&type=template&id=7b1938e9&"
import script from "./DependencyAdder.vue?vue&type=script&lang=js&"
export * from "./DependencyAdder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports